<img src="/assets/img/xmas-tree.svg" height="35" width="35" (click)="startSnow()" />
